export default __webpack_public_path__ + "assets/images/vue.2c74609.png";